export default __webpack_public_path__ + "static/media/Ies_panel_PabloBlancas.110f763a.png";